import * as React from 'react';
import { useSelector } from 'react-redux';

import { startBuyAnalytics } from '../../actions/buyAnalyticsModal';
import { AnalyticsBlockNew } from '../../components/AnalyticsBlockNew/AnalyticsBlockNew';
import { CardSectionNew } from '../../components/CardSectionNew';
import { addressSelector } from '../../selectors';
import { selectBuyAnalyticsReportPrice } from '../../selectors/buyAnalyticsModal';

export const AnalyticsBlockContainer: React.FC = () => {
  const address = useSelector(addressSelector);
  const reportPrice = useSelector(selectBuyAnalyticsReportPrice);

  const addressString = address.map(addr => addr.shortName).join(', ');

  return (
    <CardSectionNew withBorder>
      <AnalyticsBlockNew addressString={addressString} reportPrice={reportPrice} onBuyClick={startBuyAnalytics} />
    </CardSectionNew>
  );
};
